import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiAutocomplete from '@mui/material/Autocomplete';
import MuiTextField from '@mui/material/TextField';
import * as React from 'react';
import { FlagImage } from 'react-international-phone';
import { FlexBox } from '../box';
import { withPaperElevation } from '../paper';
import { styled } from '../styled';
import { FieldSkeleton } from '../textfield/utils';
import { sentence } from '../typography';
import { withVersion } from '../utils';
const OPTION_FLAG_SIZE_DEFAULT = 24;
const ADORNMENT_FLAG_SIZE = {
    small: 16,
    medium: 20
};
const Root = styled('div')(({ $width }) => ({
    width: $width
}));
const StyledFlagImage = styled(FlagImage)(({ $size }) => ({
    width: $size,
    height: $size,
    borderRadius: 4,
    objectFit: 'cover',
    flexShrink: 0
}));
const OptionWrapper = styled('li')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
}));
const handleFlagError = (e) => {
    e.currentTarget.style.visibility = 'hidden';
    if (process.env.NODE_ENV !== 'production') {
        const code = e.currentTarget.getAttribute('data-country') ?? 'unknown';
        console.warn(`[CountryPicker] Flag failed to load for code "${code}". Verify it is a valid ISO 3166-1 alpha-2 code.`);
    }
};
function CountryPickerImpl(props) {
    const { countries, value, onChange, label, required, disabled, error, skeleton, size = 'small', optionFlagSize = OPTION_FLAG_SIZE_DEFAULT, width: _width, className, 'data-role': dataRole, 'data-role-value': dataRoleValue } = props;
    const width = _width ?? '100%';
    const adornmentFlagSize = ADORNMENT_FLAG_SIZE[size];
    const selectedOption = countries.find((c) => c.code === value) ?? null;
    if (skeleton) {
        return (_jsx(FieldSkeleton, { width: width, children: _jsx(MuiTextField, { size: size, variant: "outlined", fullWidth: true, disabled: true }) }));
    }
    return (_jsx(Root, { className: className, "data-role": dataRole, "data-role-value": dataRoleValue, "$width": width, children: _jsx(MuiAutocomplete, { fullWidth: true, options: countries, value: selectedOption, disabled: disabled, disableClearable: required, slotProps: {
                paper: withPaperElevation(undefined, 'L')
            }, getOptionLabel: (option) => sentence(option.label), isOptionEqualToValue: (option, val) => option.code === val.code, onChange: (_event, newValue) => {
                onChange?.(newValue?.code);
            }, renderOption: (liProps, option) => (_jsxs(OptionWrapper, { ...liProps, children: [_jsx(StyledFlagImage, { iso2: option.code.toLowerCase(), "data-country": option.code, "$size": optionFlagSize, onError: handleFlagError }), _jsx("span", { children: sentence(option.label) })] })), renderInput: (params) => (_jsx(MuiTextField, { ...params, size: size, label: sentence(label), required: required, error: !!error, helperText: error, slotProps: {
                    ...params.slotProps,
                    input: {
                        ...params.slotProps?.input,
                        startAdornment: selectedOption ? (_jsx(FlexBox, { alignItems: "center", marginLeft: 0.5, children: _jsx(StyledFlagImage, { iso2: selectedOption.code.toLowerCase(), "$size": adornmentFlagSize }) })) : (params.slotProps?.input?.startAdornment)
                    }
                } })) }) }));
}
export const CountryPicker = withVersion(CountryPickerImpl, '1.0.0');
